module.exports = __webpack_public_path__ + "static/media/aw.65871d44.svg";